<h3 class="title configurator-title">{{ 'decking-boards.environment.title' | translate }}</h3>

<div class="config-container shadow">
  <h4 class="title configurator-subtitle">{{ 'decking-boards.environment.type-of-terrain' | translate }}</h4>

  <div class="configurator-cards-container">
    <div
      class="configurator-card"
      [ngClass]="{ active: isLocationSelected(location.id) }"
      *ngFor="let location of locations"
      (click)="selectLocation(location)">
      <img [src]="baseImgURL + location.icon.path" alt="terrain-img" class="configurator-card-img" />
      <p class="configurator-card-title" *ngIf="currentLang === 'fr'">{{ location.nameFr }}</p>
      <p class="configurator-card-title" *ngIf="currentLang === 'en'">{{ location.nameEn }}</p>
    </div>
    <ng-casto-loader *ngIf="locations === undefined"></ng-casto-loader>
  </div>

  <div
    class="location-info"
    [ngClass]="{
      'd-none': !isLocationSelected(location.id),
    }"
    id="location-info-{{ location.id }}"
    *ngFor="let location of locations">
    <div class="location-info-icon">
      <svg>
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-zoom"></use>
      </svg>
    </div>

    <div class="location-info-container">
      <h6 class="location-info-title" *ngIf="currentLang === 'fr'">
        <i
          ><strong class="more-infos">{{ 'decking-boards.environment.most-infos' | translate }}</strong> -
          <strong>{{ location.tooltip.titleFr }}</strong></i
        >
      </h6>
      <h6 class="location-info-title" *ngIf="currentLang === 'en'">
        <i
          ><strong class="more-infos">{{ 'decking-boards.environment.most-infos' | translate }}</strong> -
          <strong>{{ location.tooltip.titleEn }}</strong></i
        >
      </h6>
      <p class="terrain-info-description" *ngIf="currentLang === 'fr'">{{ location.tooltip.descriptionFr }}</p>
      <p class="terrain-info-description" *ngIf="currentLang === 'en'">{{ location.tooltip.descriptionEn }}</p>
    </div>

    <img
      *ngIf="location.tooltip.icon"
      src="{{ baseImgURL + location.tooltip.icon.path }}"
      alt="terrain-info-img"
      class="location-info-image" />
  </div>

  <!-- Hauteur de la réhausse -->
  <div class="form-row mt-5" *ngIf="displayRaisedHeight()">
    <div class="form-label">
      <label for="raised-height">{{ 'decking-boards.environment.height-raiser' | translate }}</label>
    </div>
    <div class="form-input">
      <div class="mm">
        <input
          type="number"
          [min]="1.0"
          [value]="0.0"
          [ngClass]="{
            invalid: !isAvailable,
          }"
          [(ngModel)]="raisedHeight"
          (change)="isPedestalHeightAvailable()"
          id="raised-height"
          autocorrect="off"
          spellcheck="false" />
      </div>
    </div>
  </div>

  <div class="location-info" *ngIf="displayRaisedHeight()">
    <div class="location-info-icon">
      <svg>
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-zoom"></use>
      </svg>
    </div>

    <div class="location-info-container">
      <h6 class="location-info-title" *ngIf="currentLang === 'fr'">
        <i
          ><strong class="more-infos">{{ 'decking-boards.environment.most-infos' | translate }}</strong> -
          <strong>{{ 'decking-boards.environment.height-raiser' | translate }}</strong></i
        >
      </h6>
      <p class="terrain-info-description" [innerHTML]="availableHeightString"></p>
    </div>
  </div>
</div>
